
export class BidDTO {
  bidId: string;
  testMode: boolean;
  bidMode: string;
  bidName: string;
  bidCopiedFrom: string;
  recheckFeasibility: boolean;
  feasibilityId: string;
  quotationTemplate: string;
  externalIQuoteNumber: string;
  iISSampleSupplierBU: string;
  iISSampleSupplierCurrency: string;
  jobBookProductCode: string;
  jobBookProposalNumber: string;
  externalJobBookNumber: string;
  internalJobBookNumber: string;
  contentSurveyLength: number;
  relevantSampleSize: number;
  activeDirectoryUserName: string;
  iISQuotationCurrency: string;
  budgetInSingleWave: boolean;
  mailoutsPerWave: number;
  weeksInField: number;
  waves: number;
  userRoles: string[];
  isCancelled: boolean;
  isDeleted: boolean;
  isReadOnly: boolean;
  isManuallyApproved: boolean;

  constructor() {
    this.isCancelled = false;
    this.isDeleted = false;
    this.isManuallyApproved = false;
    this.isReadOnly = false;
    this.relevantSampleSize = 0;
    this.weeksInField = 0;
    this.contentSurveyLength = 0;
    this.recheckFeasibility = false;
    this.budgetInSingleWave = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/IBidDTO.ts